"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeRegExpSpecialChar = void 0;
// biome-ignore lint/complexity/noUselessEscapeInRegex: It's OK
var REGEXP_SPECIAL_CHAR = /[\\!\\#\\$\\%\\^\\&\\*\\)\\(\\+\\=\\.\\<\\>\\{\\}\\[\]\\:\\;\\'\\"\\|\\~\\`\\_\\-]/g;
var escapeRegExpSpecialChar = function (raw) {
    return raw === null || raw === void 0 ? void 0 : raw.replace(REGEXP_SPECIAL_CHAR, '\\$&');
};
exports.escapeRegExpSpecialChar = escapeRegExpSpecialChar;
//# sourceMappingURL=string-helpers.js.map